if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.loadingSpinner = this.querySelector('.loading__spinner');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.loadingSpinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Clean up invalid selling_plan values
        if (formData.has('selling_plan')) {
          const sellingPlanValue = formData.get('selling_plan');
          if (isNaN(sellingPlanValue) || sellingPlanValue === '' || sellingPlanValue === null || sellingPlanValue === 'undefined' || sellingPlanValue === undefined) {
            formData.delete('selling_plan');
          }
        }
        
        // Remove invalid selling_plan from hidden inputs
        const sellingPlanInputs = this.form.querySelectorAll('input[name="selling_plan"]');
        sellingPlanInputs.forEach(input => {
          if (isNaN(input.value) || input.value === '' || input.value === null || input.value === 'undefined' || input.value === undefined) {
            input.remove();
          }
        });

        this.addPreorderSellingPlanFallback(formData);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.loadingSpinner?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) (this.submitButtonText || this.submitButton).textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          (this.submitButtonText || this.submitButton).textContent = window.variantStrings.addToCart;
        }
      }

      addPreorderSellingPlanFallback(formData) {
        if (this.hasValidSellingPlan(formData.get('selling_plan')) || !this.isPreorderAppContext()) return;

        const selectedVariant = this.getSelectedVariant();
        const sellingPlanAllocation = selectedVariant?.selling_plan_allocations?.[0];
        const sellingPlanId = sellingPlanAllocation?.selling_plan_id || sellingPlanAllocation?.selling_plan?.id;

        if (this.hasValidSellingPlan(sellingPlanId)) {
          formData.set('selling_plan', sellingPlanId);
        }
      }

      getSelectedVariant() {
        const productInfo = this.closest('product-info') || document;
        const selectedVariantJson = productInfo.querySelector('variant-selects [data-selected-variant]')?.textContent;

        if (!selectedVariantJson) return null;

        try {
          return JSON.parse(selectedVariantJson);
        } catch (error) {
          console.warn('Unable to parse selected variant for preorder fallback', error);
          return null;
        }
      }

      hasValidSellingPlan(value) {
        return value !== null && value !== undefined && value !== '' && value !== 'undefined' && !Number.isNaN(Number(value));
      }

      isPreorderAppContext() {
        const productInfo = this.closest('product-info') || document;
        const preorderText = [
          this.submitButton?.textContent,
          this.submitButton?.value,
          this.form?.className,
          this.submitButton?.className,
          productInfo.querySelector('.preorder-description')?.textContent,
        ]
          .filter(Boolean)
          .join(' ');

        return /pre\s*-?\s*order/i.test(preorderText) || /preorder/i.test(preorderText);
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
